import { trimStart } from 'lodash';
import { BLOG_APP_ID, FORUM_APP_ID, MEMBERS_APP_ID } from '../constants/applications';
import { BLOG_PAGE_ID, FORUM_PAGE_ID, MEMBERS_PAGE_ID } from '../constants/component-ids';
import Wix from '../services/wix-sdk-polyfill';

export const navigateToBlog = location => Wix.Utils.navigateToSection({
  appDefinitionId: BLOG_APP_ID,
  sectionId: BLOG_PAGE_ID,
  shouldRefreshIframe: false,
}, trimStart(location, '/'), console.error);

export const navigateToForum = location => Wix.Utils.navigateToSection({
  appDefinitionId: FORUM_APP_ID,
  sectionId: FORUM_PAGE_ID,
  shouldRefreshIframe: false,
}, trimStart(location, '/'), console.error);

export const navigateToMembers = location => Wix.Utils.navigateToSection({
  appDefinitionId: MEMBERS_APP_ID,
  sectionId: MEMBERS_PAGE_ID,
  shouldRefreshIframe: false,
}, trimStart(location, '/'), console.error);



// WEBPACK FOOTER //
// ./app/services/navigate-to-section.js